<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>RI Company Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doSelect">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field
                append-icon="mdi-magnify"
                single-line
                hide-details
                v-model="filters.searchKey"
                :label="labels.searchKey"
                @keyup="filter"
              ></v-text-field>
              <v-data-table
                :headers="headers"
                :items="items"
                v-bind:options.sync="paginationInsured"
                :footer-props="{ 'items-per-page-options': itemsPerPage }"
                :server-items-length="totalItems"
                :loading="loading"
                class="elevation-1"
                :no-data-text="noDataText"
                item-key="key"
                v-model="selected"
                show-select
                @input="enterSelect"
                @toggle-select-all="enterSelectAll(pagination, items, selected)"
              >
              </v-data-table>
              <v-textarea label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class="mr-2" @click="doSelect('All', 'riCo')">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class="mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class="mr-2" @click="doSelect('', 'riCo')">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import clone from 'clone'
import { expandURI, filterQuery } from '@/utils/ajax'

export default {
  props: {
    riType: String,
    refresh: Boolean
  },
  data() {
    return {
      labels: {
        searchKey: 'Search',
        riCo: 'Insured Reference',
        desc: 'Full Name'
      },
      filters: {
        searchKey: undefined
      },
      selected: [],
      totalItems: 0,
      paginationInsured: {
        sortDesc: [false],
        page: 1,
        itemsPerPage: 5
      },
      headers: [],
      timeout: undefined,
      tempCheckedItems: [],
      tempRIType: undefined
    }
  },
  mounted() {
    this.fetchData()
  },
  computed: {
    menu() {
      return this.$store.state.commons.menu
    }
  },
  watch: {
    menu: function () {
      // this.doInit()
    },
    refresh: function (value) {
      this.fetchData()
    },
    paginationInsured: function (value) {
      this.fetchData()
    }
  },
  methods: {
    setHeaders() {
      if (this.riType === 'F' || this.riType === 'C') {
        this.headers = [
          { text: 'RI Co.', value: 'riCo', sortable: false },
          { text: 'Description', value: 'desc', sortable: false }
        ]
      }
      if (this.riType === 'T' || this.riType === 'W' || this.riType === 'X') {
        this.headers = [
          { text: 'RI Co.', value: 'riCo', sortable: false },
          { text: 'Description', value: 'desc', sortable: false },
          { text: 'Treaty Year', value: 'ttyYr', sortable: false }
        ]
      }
    },
    async fetchData() {
      this.setHeaders()
      this.totalItems = 0
      if (this.tempRIType !== this.riType) {
        this.tempCheckedItems = []
        this.checkedItems = []
        this.doReset()
      } else {
        this.tempCheckedItems = this.checkedItems
      }
      this.tempRIType = this.riType
      this.items = []
      const apiUrl = this.menu.riCoList
      if (apiUrl) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.paginationInsured
          const expand = {
            page: page - 1,
            size: itemsPerPage,
            riType: this.riType,
            filter: this.filters.searchKey
          }

          let massageFilters = clone(this.filters)
          const result = await this.$http.get(
            filterQuery(expandURI(apiUrl, expand), massageFilters, this.paginationInsured.sortBy, this.paginationInsured.sortDesc)
          )
          if (result.data) {
            this.totalItems = result.data.dataMap.totalElements
            this.items = []

            const { riCoList } = result.data.dataMap
            if (riCoList) {
              riCoList.map((param) => {
                const convertList = {
                  key: param.riCo,
                  riCo: param.riCo,
                  desc: param.desc,
                  ttyYr: param.ttyYr
                }
                this.items.push(convertList)

                if (this.checkedItems.includes(param.riCo)) {
                  const selectedInsuredList = {
                    key: param.riCo,
                    riCo: param.riCo,
                    desc: param.desc,
                    ttyYr: param.ttyYr
                  }
                  this.selectedItems.push(selectedInsuredList)
                }
              })
            }
            this.loading = false
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
          }
          this.loading = false
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    },
    doClearFilters() {
      this.filters.searchKey = null
      this.fetchData()
    },
    doFilters() {
      this.paginationInsured.page = 1
      this.fetchData()
    },
    filter() {
      if (this.timeout) {
        clearTimeout(this.timeout)
      }
      this.timeout = setTimeout(this.doFilters, 500)
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin, commonAjaxMixin]
}
</script>
